import { OverallTrip, TripDTO } from '../types/trip';
import { EVENT_MESSAGE_IDS } from './constants';
import { transformEventCode } from './transform-event-code';

export function calculateOverallTrip(trips: TripDTO[]): OverallTrip | null {
  if (!trips.length) return null;

  const allMessages = trips.flatMap((trip) => trip.messages || []);
  const hasMessages = !!allMessages.length;
  if (!hasMessages) return null;

  const firstTrip = trips[0];
  const lastTrip = trips[trips.length - 1];

  if (!firstTrip) {
    return null;
  }

  return {
    startTime: firstTrip.startTime,
    endTime: lastTrip.endTime,
    distance: trips.reduce((acc, trip) => acc + (trip.distance || 0), 0),
    messages: allMessages,
    startLatitude: firstTrip.startLatitude,
    startLongitude: firstTrip.startLongitude,
    endLatitude: lastTrip.endLatitude,
    endLongitude: lastTrip.endLongitude,
    startAddress: firstTrip.startAddress,
    endAddress: lastTrip.endAddress,
    events: allMessages
      .filter((msg) => EVENT_MESSAGE_IDS.includes(msg.eventId))
      .map(transformEventCode),
  };
}
